/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface User { 
    id?: number;
    password?: string;
    firstName?: string;
    lastName?: string;
    city?: string;
    resid_prov?: string;
    resid_nation_iso?: string;
    registrationCity?: string;
    social_security_number?: string;
    telephone?: string;
    address?: string;
    gender?: User.GenderEnum;
    email?: string;
    onboarding_completed?: boolean;
    driver_license_country?: string;
    birth_date?: string;
    birth_place?: string;
    cap?: string;
    country_iso?: string;
    tel_country_iso?: string;
    tel_country_prefix?: string;
    external_code?: string;
    attributes?: string;
    odometer?: number;
    blocked?: boolean;
    email_confirmed?: boolean;
    account_confirmed?: boolean;
    usage_conditions_accepted?: boolean;
    privacy_conditions_accepted?: boolean;
    unfair_terms_accepted?: boolean;
    charger_enabled?: boolean;
    roleId?: number;
    roleAssumed?: number;
    pricingPlanId?: number;
    tempPricingPlanId?: number;
    tempPricingPlanExpiration?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    deletedAt?: Date;
    fullSubscription?: boolean;
    tester?: boolean;
    developer?: boolean;
    userWalletId?: number;
    ticketType_auto?: boolean;
    ticketTypeId?: number;
    enteId?: number;
    fcm_token?: string;
}
export namespace User {
    export type GenderEnum = 'Male' | 'Female' | 'NullGender';
    export const GenderEnum = {
        Male: 'Male' as GenderEnum,
        Female: 'Female' as GenderEnum,
        NullGender: 'NullGender' as GenderEnum
    };
}